import styled, { css } from 'styled-components';
import { em } from 'polished';
import { Link } from 'react-router-dom';
import { colors } from 'core/theme';
import { media } from 'core/layout';

export const StyledItem = styled.li`
  display: flex;
  align-items: center;

  i {
    color: ${colors.hairline};
    margin: 0 0.5em;
  }

  @media print {
    i {
      display: none !important;
    }
  }
`;

export const StyledLink = styled(Link) `
  color: ${colors.lightText};
  padding: 0.5em 0;

  &:hover,
  &:active {
    color: ${colors.primary};
  }

  ${({ truncate }) => truncate && css`
      display: block;
      overflow-x: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width: ${em(truncate)};
  `};

  ${media.tabletSmall`
    font-size: ${em(14)};
  `};
`;



// WEBPACK FOOTER //
// ./src/elements/Breadcrumbs/components/BreadcrumbItem/styled.js